import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    class: "flex items-center flex-shrink-0 gap-3 px-5 bg-white border-b",
    style: { "height": "64px", "border-color": "#e5e7eb" }
};
const _hoisted_2 = { class: "flex-1 min-w-0 flex flex-col gap-[2px]" };
const _hoisted_3 = { class: "text-[15px] font-bold text-[#1A1A1A] truncate" };
const _hoisted_4 = { class: "flex flex-wrap items-center gap-2" };
const _hoisted_5 = { class: "flex items-center gap-1" };
const _hoisted_6 = {
    key: 0,
    class: "text-[12px] text-[#9CA3AF]"
};
const _hoisted_7 = { class: "flex items-center flex-shrink-0 gap-2" };
const _hoisted_8 = ["disabled"];
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { IconCircleX, IconX } from "@tabler/icons-vue";
import { getLoginUserId } from "@/plugins/shared";
import CloseConversationModal from "./CloseConversationModal.vue";
import { conversationService } from "../services/conversation.service";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConversationHeader',
    props: {
        conversation: {},
        showBack: { type: Boolean },
        isClosing: { type: Boolean }
    },
    emits: ["close", "back"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const showCloseModal = ref(false);
        const currentUserId = String(getLoginUserId());
        const { t } = useI18n();
        const otherParticipant = computed(() => {
            return (props.conversation.participants.find((p) => p.id !== currentUserId) ??
                props.conversation.participants[0] ??
                null);
        });
        const otherName = computed(() => otherParticipant.value?.name ?? props.conversation.service_name_snapshot ?? '');
        const initials = computed(() => conversationService.getInitials(otherName.value));
        const avatarColor = computed(() => conversationService.getAvatarColor(props.conversation.id, props.conversation.status === "CLOSED"));
        function handleConfirmClose() {
            emit("close");
            showCloseModal.value = false;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", {
                        class: "flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full text-white text-[14px] font-bold",
                        style: _normalizeStyle({ backgroundColor: avatarColor.value })
                    }, _toDisplayString(initials.value), 5),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("p", _hoisted_3, _toDisplayString(otherName.value), 1),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("span", {
                                    class: "w-2 h-2 rounded-full",
                                    style: _normalizeStyle({
                                        backgroundColor: __props.conversation.status === 'ACTIVE' ? '#22C55E' : '#9CA3AF',
                                    })
                                }, null, 4),
                                _createElementVNode("span", {
                                    class: "text-[12px]",
                                    style: _normalizeStyle({
                                        color: __props.conversation.status === 'ACTIVE' ? '#16A34A' : '#9CA3AF',
                                    })
                                }, _toDisplayString(__props.conversation.status === "ACTIVE"
                                    ? _unref(t)("conversation.status.active_feminine")
                                    : _unref(t)("conversation.status.closed_feminine")), 5)
                            ]),
                            (__props.conversation.itinerary_code_snapshot)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, " · " + _toDisplayString(__props.conversation.itinerary_code_snapshot), 1))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        (__props.conversation.status === 'ACTIVE')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                disabled: __props.isClosing,
                                onClick: _cache[0] || (_cache[0] = ($event) => (showCloseModal.value = true)),
                                class: "flex items-center gap-1.5 h-8 px-3 text-xs font-medium rounded-md border disabled:opacity-50",
                                style: { "background-color": "#fef2f2", "border-color": "#fecaca", "color": "#dc2626" }
                            }, [
                                _createVNode(_unref(IconCircleX), { class: "w-4 h-4" }),
                                _createTextVNode(" " + _toDisplayString(_unref(t)("conversation.actions.close_conversation")), 1)
                            ], 8, _hoisted_8))
                            : _createCommentVNode("", true),
                        (__props.showBack)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('back'))),
                                class: "flex items-center justify-center w-8 h-8 rounded-md",
                                style: { "background-color": "#f5f6fa" }
                            }, [
                                _createVNode(_unref(IconX), { class: "w-4 h-4 text-gray-500" })
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                (showCloseModal.value)
                    ? (_openBlock(), _createBlock(CloseConversationModal, {
                        key: 0,
                        "is-loading": __props.isClosing,
                        onConfirm: handleConfirmClose,
                        onCancel: _cache[2] || (_cache[2] = ($event) => (showCloseModal.value = false))
                    }, null, 8, ["is-loading"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
